<template>
  <layout :showuserinfo="true" :title="'' + $page.props.app_name">

  </layout>
</template>

<script>
export default {
data() {
    return {
  errors: [],
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  data: {
    nama: '',
    samaran: '',
    userid: ''
  },
  validators: {
    required: value => !!value || 'Medan ini adalah wajib',
    consent: value => !!value || 'Anda mesti setuju'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
}},
methods: {
  onSuccess () {
    // this.$waveui.notify('Dropping table...', 'error', 3000)
    this.$zcomm.post(route('updateuser'),this.data)
    .then(res => {
      this.data = res
      this.form.sent = true
    })
    .catch(err => {
      this.form.valid = false
      this.form.submitted = false
      this.$page.props.errors = err.response.data.errors
      this.errors = err.response.data.errors
      this.form.errorsCount = this.errors ? Object.keys(this.errors).length : 0
    })
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
}
}

</script>

<style>


</style>